import React, { useEffect } from "react";

import { CheckIcon } from "@heroicons/react/24/outline";

const PolicyCheckbox = ({
  checked,
  setChecked,
  promptText,
  policyName,
  policyLink,
  fieldWarning,
  setFieldWarning,
}) => {
  useEffect(() => {
    checked && setFieldWarning(false);
  }, [checked]);

  return (
    <div className="flex flex-row items-center mt-6 w-full sm:w-4/5 Xbg-red-500">
      <input
        id={`link-checkbox-${policyName}`}
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          setChecked(e.target.checked);
        }}
        className="hidden"
      />
      <label
        htmlFor={`link-checkbox-${policyName}`}
        className="flex items-center text-sm font-light cursor-pointer"
      >
        <div
          className={`flex justify-center items-center w-5 h-5 border rounded-md border-gray-300 ${
            fieldWarning ? "bg-rose-100" : ""
          }`}
        >
          {checked ? (
            <CheckIcon className="h-4 w-4 flex-none text-neutral-950" />
          ) : null}
        </div>
      </label>

      <div className="w-full Xbg-red-500 pl-2">
        <p className="Xbg-blue-500 inline text-sm font-light">{promptText} </p>

        <a
          href={policyLink}
          className="text-sm font-light cursor-pointer text-blue-700 hover:underline hover:text-blue-800 hover:font-normal duration-150"
          rel="noopener noreferrer"
          target="_blank"
        >
          {policyName}
        </a>
      </div>
    </div>
  );
};

export default PolicyCheckbox;
